import { SVGAttributes } from "react";

export const BoldIcon = (
  props: SVGAttributes<SVGElement> & { size: "small" | "regular" }
) => {
  if (props.size === "small") {
    return (
      <svg
        width={16}
        height={16}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M4 4a1 1 0 010-2h5.5c.454 0 1.065.102 1.697.418C12.306 2.972 13 4.013 13 5.5c0 1.487-.694 2.528-1.803 3.082A3.859 3.859 0 019.5 9H6a1 1 0 010-2h3.5c.171 0 .498-.054.803-.207.454-.227.697-.592.697-1.293 0-.7-.243-1.066-.697-1.293A1.982 1.982 0 009.5 4H4z"
          fill="currentColor"
        />
        <path
          d="M6 9a1 1 0 010-2h4.5c.454 0 1.065.102 1.697.418C13.306 7.972 14 9.013 14 10.5c0 1.487-.694 2.527-1.803 3.082A3.859 3.859 0 0110.5 14H4a1 1 0 110-2h6.5c.171 0 .498-.055.803-.207.454-.227.697-.592.697-1.293 0-.7-.243-1.066-.697-1.293A1.982 1.982 0 0010.5 9H6z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4 14h2V2H4v12z"
          fill="currentColor"
        />
      </svg>
    );
  } else {
    return (
      <svg
        width={24}
        height={24}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7 17V7H6a1 1 0 010-2h7c3.333 0 5 1.365 5 4.095 0 1.014-.23 1.83-.69 2.45 1.46.621 2.19 1.773 2.19 3.455 0 2.667-1.833 4-5.5 4H6a1 1 0 110-2h1zm2-6l4.076.001c2.282.087 2.924-.414 2.924-1.906C16 7.568 15.307 7 13 7H9v4zm5 6H9v-4h5c2.674 0 3.5.6 3.5 2s-.826 2-3.5 2z"
          fill="currentColor"
        />
      </svg>
    );
  }
};
BoldIcon.displayName = "BoldIcon";
